(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Video Modals Section Functionality
    /*****************************************************/
    if ($(".video-modal-section").length) {
      console.log("video-modals.js initiated");

      initializeVideoModals();
    }

    function initializeVideoModals() {
      // Handle video modal button clicks
      $(document).on("click", ".video-modal-button", handleVideoModalClick);

      // Handle video modal button keyboard events
      $(document).on("keydown", ".video-modal-button", handleVideoModalKeyDown);

      // Handle modal close button clicks
      $(document).on("click", ".closeModalBtn", handleCloseModal);

      // Handle ESC key to close modal
      $(document).on("keydown", handleKeyDown);

      // Handle clicking outside modal to close
      $(document).on("click", "#videoModal", handleOutsideClick);
    }

    function handleVideoModalClick(event) {
      event.preventDefault();

      const button = $(event.currentTarget);
      const videoUrl = button.data("video-url");
      const videoMediaType = button.data("video-media-type");

      if (!videoUrl) {
        console.error("No video URL provided");
        return;
      }

      openVideoModal(videoUrl, videoMediaType);
    }

    function handleVideoModalKeyDown(event) {
      // Handle Enter and Space key presses for video modal buttons
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleVideoModalClick(event);
      }
    }

    function openVideoModal(videoUrl, videoMediaType) {
      const modal = $("#videoModal");
      const videoContainer = $("#modalVideoContainer");

      // Clear previous content
      videoContainer.empty();

      // Create video content based on media type
      let videoContent = "";

      if (videoMediaType === "YouTube Video") {
        // Extract YouTube video ID from URL
        const videoId = extractYouTubeVideoId(videoUrl);
        if (videoId) {
          videoContent = `
            <iframe 
              src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen
              style="border: none;">
            </iframe>
          `;
        } else {
          console.error("Invalid YouTube URL");
          return;
        }
      } else if (videoMediaType === "Upload Video") {
        // Handle uploaded video file
        const videoExtension = getVideoExtension(videoUrl);
        videoContent = `
          <video 
            controls 
            autoplay>
            <source src="${videoUrl}" type="video/${videoExtension}">
            Your browser does not support the video tag.
          </video>
        `;
      }

      // Insert video content
      videoContainer.html(videoContent);

      // Show modal
      modal.show();
      $("body").addClass("modal-open");

      // Focus on close button for accessibility
      setTimeout(() => {
        $(".closeModalBtn").focus();
      }, 100);
    }

    function handleCloseModal(event) {
      event.preventDefault();
      closeVideoModal();
    }

    function handleKeyDown(event) {
      // Close modal on ESC key
      if (event.key === "Escape" && $("#videoModal").is(":visible")) {
        closeVideoModal();
      }
    }

    function handleOutsideClick(event) {
      // Close modal when clicking outside video content
      if (event.target.id === "videoModal") {
        closeVideoModal();
      }
    }

    function closeVideoModal() {
      const modal = $("#videoModal");
      const videoContainer = $("#modalVideoContainer");

      // Stop video playback
      const iframe = videoContainer.find("iframe");
      const video = videoContainer.find("video");

      if (iframe.length) {
        // For YouTube videos, we can't directly stop them, but we can remove the iframe
        iframe.remove();
      }

      if (video.length) {
        // For uploaded videos, pause and reset
        video[0].pause();
        video[0].currentTime = 0;
      }

      // Clear container
      videoContainer.empty();

      // Hide modal
      modal.hide();
      $("body").removeClass("modal-open");

      // Return focus to the button that opened the modal
      $(".video-modal-button:focus").focus();
    }

    function extractYouTubeVideoId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    }

    function getVideoExtension(url) {
      const extension = url.split(".").pop().toLowerCase();
      const extensionMap = {
        mp4: "mp4",
        webm: "webm",
        ogg: "ogg",
        mov: "mp4",
        avi: "mp4",
      };
      return extensionMap[extension] || "mp4";
    }
  });
})(jQuery);
